import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class ContableGastoApi {
    
    static activar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/contablegasto/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/contablegasto/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getContableGastoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablegasto?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getContableGasto(id, token ) {  
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablegasto/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(contablegasto, token ) {          
      let contablegastoEnvio = Object.assign({}, contablegasto);
		let comando="POST";
		if (contablegastoEnvio.id > 0) {
			comando="PUT";			
		} 
		contablegastoEnvio=JSON.stringify(contablegastoEnvio);
		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablegasto/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: contablegastoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getContableGastoCombo(token ) {

		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablegasto/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}